import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import {
  Modal,
  StatusIndicator,
} from '@unified-checkout/design-system';
import { TrashCan } from '@unified-checkout/design-system/icons/index';

import {
  DELETE_STATUS,
  MODAL_STEP_STATUS,
} from '@app/dashboard/constants/Bills';
import { deleteSavedMerchant } from '@app/dashboard/services/inner_layout/bills/delete-saved-merchants';

import type { IDeleteModal } from '@app/dashboard/types/innerLayout/bills/delete-modal';

import { isStatusVisible } from '../../../utils';
import styles from './delete.module.scss';
const THERE_SECONDS = 3000;
export const DeleteModal = ({
  isOpen,
  merchantName,
  onClose,
  id,
  refetch
}: IDeleteModal) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState<string>(MODAL_STEP_STATUS.CONFIRM);

  const deleteStatusContent = DELETE_STATUS(t).find((item) => item.id === status);

  const {
    mutate: handleDelete,
    isPending: isDeletingLoading,
  } = useMutation({
    mutationFn: () => deleteSavedMerchant(String(id)),
    onSuccess: () => {
      setStatus(MODAL_STEP_STATUS.SUCCESS);
      setTimeout(() => {
        refetch();
        onClose();
        setStatus(MODAL_STEP_STATUS.CONFIRM);
      }, THERE_SECONDS);
    },
    onError: () => {
      setStatus(MODAL_STEP_STATUS.FAILED);
      setTimeout(() => {
        onClose();
        setStatus(MODAL_STEP_STATUS.CONFIRM);
      }, THERE_SECONDS);

    }
  });

  const modalBtnsProps = status === MODAL_STEP_STATUS.CONFIRM ? [
    {
      text: t('innerLayout.billsPage.deleteModal.confirmButton'),
      onClickHandler: handleDelete,
      color: 'danger' as const,
      loading: isDeletingLoading,
      disabled: isDeletingLoading,
    },
    {
      color: "secondary" as const,
      variant: "outlined" as const,
      text: t('innerLayout.billsPage.deleteModal.cancelButton'),
      onClickHandler: onClose,
      disabled: isDeletingLoading,
    },
  ] : undefined;

  return (
    <div className={styles["delete-modal"]}>
      <Modal
        state={status === MODAL_STEP_STATUS.CONFIRM ? 'danger' : 'primary'}
        headerIcon={status === MODAL_STEP_STATUS.CONFIRM ? TrashCan : undefined}
        hasCloseIcon
        open={isOpen}
        onCloseHandler={onClose}
        title={!isStatusVisible(status) && t('innerLayout.billsPage.deleteModal.title')}
        supportingText={!isStatusVisible(status) && t('innerLayout.billsPage.deleteModal.supportingText').replace('{{name}}', merchantName || '')}
        btnsProps={modalBtnsProps}
      >
        {isStatusVisible(status) &&
          <StatusIndicator
            status={deleteStatusContent?.status}
            icon={deleteStatusContent?.icon}
            hintText={deleteStatusContent?.hintText}
          />
        }
      </Modal>
    </div>
  );
}

